$(function () {

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    const validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault();
            event.stopPropagation();

            form.classList.add('was-validated');

            if (form.checkValidity() === false) {
                return;
            }

            // captcha
            grecaptcha.ready(function () {
                grecaptcha.execute('6Lej8uwsAAAAAKF1KWd124PIzIxQgtJCkLVE5EUT', { action: 'submit' }).then(function (token) {
                    const RecaptchaResponseField = form.querySelector('[name="RecaptchaResponse"]');

                    if (RecaptchaResponseField) {
                        RecaptchaResponseField.value = token
                    }

                    form.submit();
                });
            });

        }, false);
    });

});